import React from 'react';
import '../template-file-css/document-file-template.css';


export const ROC_AuthorizationReleaseOfInformation = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ROC_AuthorizationReleaseOfInformation' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <center> <b>Authorization for Release of Information </b></center> </p>
                <p className='w-750'>
                    I <input type='text' id='txtConsumerGuardianAuthorizationReleaseOfInformation' name='txtConsumerGuardianAuthorizationReleaseOfInformation' className='add-only w-250 custom-add-only' /> &Nbsp;

                    (consumer/guardian) understand that this authorization is voluntary. I understand that my health information may be protected by the Federal Rules for Privacy of Individually Identifiable Health Information (Title 45 of the Code of Federal Regulations, Parts 160 and 164), the Federal Rules for Confidentiality of Alcohol and Drug Abuse Patient Records (Title 42 of the Code of Federal Regulations, Chapter I, Part 2), and/or state laws.
                </p>
                <p className='w-750'>
                    I understand that my health information may be subject to re-disclosure by the recipient and that if the organization or person authorized to receive the information is not a health plan or health care provider, the released information may no longer be protected by the Federal privacy regulations.
                    <br />
                    I understand that my records may contain information regarding my mental health, substance use or dependency, or sexuality, and also may contain confidential HIV/AIDS-related information. I further understand that by signing below, I am authorizing the release or exchange of these records to the parties named below.
                    <br />
                    I also understand that my health plan may not condition treatment, payment, enrollment, or eligibility for benefits on whether I sign this form, except for certain eligibility or enrollment determination prior to my enrollment in its health plan, and for health care that is solely for the purpose of creating protected health information for disclosure to a third party.

                </p>
                <p className='w-750'>
                    I, <input type='text' id='txtConsumerGuardianAuthorizationReleaseOfInformation_2' name='txtConsumerGuardianAuthorizationReleaseOfInformation_2' className='add-only  w-250 custom-add-only' /> authorize Restore Outreach Center, LLC effective , and to expire one year from the beginning date, to disclose and/or obtain information from:


                    <textarea id='txtObtainInformationAuthorizationReleaseOfInformation_2' name='txtObtainInformationAuthorizationReleaseOfInformation_2' className='add-only'></textarea>

                </p>

                <table>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>The following information from Restore Outreach Center:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='rbInformation_1' name='rbInformation_1' className='add-only' value='Information_1' /> All Listed Below</td>
                        <td className='w-250'><input type='checkbox' id='rbInformation_2' name='rbInformation_2' className='add-only' value='Information_2' /> Medical Records</td>
                        <td className='w-250'><input type='checkbox' id='rbInformation_3' name='rbInformation_3' className='add-only' value='Information_3' /> Case Coordination</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='rbInformation_4' name='rbInformation_4' className='add-only' value='Information_4' /> Assessment</td>
                        <td className='w-250'><input type='checkbox' id='rbInformation_5' name='rbInformation_5' className='add-only' value='Information_5' /> Psychiatric Evaluation</td>
                        <td className='w-250'><input type='checkbox' id='rbInformation_6' name='rbInformation_6' className='add-only' value='Information_6' /> Diagnosis</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='rbInformation_7' name='rbInformation_7' className='add-only' value='Information_7' /> Treatment Plan</td>
                        <td className='w-250'><input type='checkbox' id='rbInformation_8' name='rbInformation_8' className='add-only' value='Information_8' /> Discharge Summary</td>
                        <td className='w-250'><input type='checkbox' id='rbInformation_9' name='rbInformation_9' className='add-only' value='Information_9' /> Medical Information</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='rbInformation_10' name='rbInformation_10' className='add-only' value='Information_10' /> Participation in Treatment</td>
                        <td className='w-250'><input type='checkbox' id='rbInformation_11' name='rbInformation_11' className='add-only' value='Information_11' /> Psychological Testing</td>
                        <td className='w-250'><input type='checkbox' id='rbInformation_12' name='rbInformation_12' className='add-only' value='Information_12' />  Educational Information</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='rbInformation_13' name='rbInformation_13' className='add-only' value='Information_13' />  Other:

                            <input type='text' id='txtInformation_13' name='txtInformation_13' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Purpose:</span>
                    This information may be used or disclosed in connection with mental health treatment, payment, or healthcare operations. I understand that I have a right to revoke this authorization, in writing, at any time by sending written notification to Restore Outreach Center, LLC. I further understand that a revocation of the authorization is not effective to the extent that action has been taken in reliance on the authorization.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Form of Disclosure:</span>
                    Unless you have specifically requested in writing that the disclosure be made in a certain format, we reserve the right to disclose information as permitted by this authorization in any manner that we deem to be appropriate and consistent with applicable law, including, but not limited to, verbally, in paper format or electronically.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Print & Signature of Client  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>  Print & Signature of Parent/Guardian</td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>




            </div>
        </form>

    )
}